import React from "react";
import { stepFourData } from "./stepData";
import { Typography } from "@mui/material";

const StepFour = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFourData[0].heading}
          </Typography>
        </div>
        <ol
          style={{
            listStyle: "number",
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0.08px",
            fontWeight: 500,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="mt-3"
        >
          <li className="mt-2">Select Car Loan from the options.</li>
          <li className="mt-2">
            Enter the loan amount, interest rate, and tenure.
          </li>

          <li className="mt-2">
            Instantly view EMI, total repayment, and interest costs.
          </li>
          <li className="mt-2">
            Adjust values to compare different loan scenarios.
          </li>
          <li className="mt-2">
            Choose the best plan for your budget and apply seamlessly.
          </li>
        </ol>
      </div>
    </>
  );
};

export default StepFour;
